
<div>
  <!-- <container-element> -->
    @switch (params.dataType) {
      @case ('date') {
        <some-element>
          <input  type="date" class="form-control" id="fieldToEdit" [(ngModel)]="cellData">
        </some-element>
      }
      @case ('number') {
        <some-element>
          <input  type="number" class="form-control" id="fieldToEdit" [(ngModel)]="cellData">
        </some-element>
      }
      @case ('text') {
        <some-element>
          <input  type="text" class="form-control" id="fieldToEdit" [(ngModel)]="cellData" >
        </some-element>
      }
      @case ('list') {
        <div>
          <select class="form-control"  [(ngModel)]="cellData" data-style="btn-info" #data>
            @for (data of listData; track data) {
              <option >{{data}}
              </option>
            }
          </select>
        </div>
      }
      @default {
        <some-element>
          <input  type="text" class="form-control" id="fieldToEdit" [(ngModel)]="cellData">
        </some-element>
      }
    }
  <!-- </container-element> -->
  <button (click)="buttonClicked($event)" class="btn btn-primary btn-sm mt-1" data-toggle="tooltip" data-placement="bottom" title="Paste To All"> <i class="fa fa-paste"></i></button>
</div>



